if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();

      this.content = this.querySelector('.read-more__content');
      this.toggleButton = this.querySelector('.read-more__toggle');
      this.toggleButton.addEventListener('click', this.onToggle.bind(this));
      this.resizeObserver = new ResizeObserver(this.update.bind(this));
    }

    connectedCallback() {
      this.resizeObserver.observe(this.content);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }

    update() {
      if (this.hasAttribute('expanded')) return;

      this.toggleButton.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
    }

    onToggle() {
      const expanded = this.toggleAttribute('expanded');
      this.toggleButton.setAttribute('aria-expanded', expanded);
      this.update();
    }
  }
  customElements.define('read-more', ReadMore);
}
